import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';


export const MaintenanceAndCost = () => {
        return (
        <div id="maintenance-and-cost">
                <ContentBlock className="evFundamentalsSection">
                    <ContentHeading title="Maintenance and Costs" />
                    <ContentBody>
                        <div className="heading5">One crucial factor to always consider when investing in any vehicle is how much it will cost in the long run through maintenance, servicing, and normal wear and tear. This is where EVs, like battery electric vehicles (BEVs) and plug-in hybrid electric vehicles (PHEVs), tend to shine when compared to their conventional gas-powered counterparts. That means you get more bang for your buck every mile you drive electric.</div>
                        <Row className="tableBlock">
                            <Col>
                                <Table responsive striped className="averageLifetimeMaintenanceCosts">
                                    <caption>Average Lifetime Maintenance Costs ($/mile)</caption>
                                    <thead>
                                        <tr>
                                            <th className="text-left">Vehicle Type</th>
                                            <th>Conventional</th>
                                            <th>BEV</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-left">Sedan</td>
                                            <td>$0.150<sup className={'super-footnote'}>2</sup></td>
                                            <td>$0.133</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">Pickup Truck</td>
                                            <td>$0.163<sup className={'super-footnote'}>2</sup></td>
                                            <td>$0.146</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">SUV</td>
                                            <td>$0.151<sup className={'super-footnote'}>2</sup></td>
                                            <td>$0.134</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">Van</td>
                                            <td>$0.211<sup className={'super-footnote'}>2</sup></td>
                                            <td>$0.194</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">Refuse Truck</td>
                                            <td>$2.890<sup className={'super-footnote'}>3</sup></td>
                                            <td>$2.830</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">Shuttle Bus</td>
                                            <td>$0.260<sup className={'super-footnote'}>3</sup></td>
                                            <td>$0.190</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">Transit Bus</td>
                                            <td>$0.790<sup className={'super-footnote'}>3</sup></td>
                                            <td>$0.600</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left">School Bus</td>
                                            <td>$0.935<sup className={'super-footnote'}>3</sup></td>
                                            <td>$0.870</td>
                                        </tr>
                                    </tbody>
                                </Table>

                                <div className="disclaimer">
                                    <p>
                                        <sup className={'super-footnote'}>2</sup>Gasoline
                                        <br /><sup className={'super-footnote'}>3</sup>Diesel
                                        <br />Sources: Argonne National Laboratory, California Electric Transportation Coalition
                                    </p>
                                </div>

                                <div className="subContent">
                                    <h4 className="css_heading bold">Battery Maintenance</h4>
                                    <div className="body indent">
                                        <p>EV batteries are designed to last for the expected vehicle lifetime. Most manufacturers offer 8-year/100,000-mile warranties for their EV batteries. For improved battery performance and health follow these best practices:</p>
                                        <ul>
                                            <li>Perform regular checks of the battery coolant system, if applicable.</li>
                                            <li>Avoid fully charging and fully discharging. For PHEVs, consider "mountain mode" for hilly travel.</li>
                                            <li>Minimize the time spent at a high state of charge. If possible, manage charging so the vehicle is at the charge level needed about 60 minutes before duty cycle begins.</li>
                                            <li>Minimize use of DC fast chargers. If DC fast charging is the primary fueling method, battery capacity may be reduced over the vehicle's lifetime.</li>
                                        </ul>
                                    </div>
                                    <h4 className="css_heading bold">Additional Considerations</h4>
                                    <div className="body indent">
                                        <p>
                                            <h5 className="css_heading bold">EVs have optimized stability on the road</h5>
                                            EVs have a lower center of gravity, due to the weight and positioning of the electric battery. This makes EVs particularly stable when driving on snow and ice.
                                        </p>
                                    </div>
                                    <div className="body indent">
                                        <p>
                                            <h5 className="css_heading bold">EVs can be optimized for winter operation</h5>
                                            <ul>
                                                <li>Extreme outside temperatures can reduce range by up to 50%.</li>
                                                <li>It is recommended to keep the vehicle plugged in while heating the cabin in wintertime.</li>
                                                <li>Alternatively, save energy and alleviate winter range issues by using efficient heating features for passenger comfort (e.g., heated seats and steering wheel).</li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div className="body indent">
                                        <p>
                                            <h5 className="css_heading bold">EV driving can be optimized to preserve range</h5>
                                            To capitalize on range, EV drivers should:
                                            <ul>
                                                <li>Drive smoothly, with gentle accelerations.</li>
                                                <li>Use regenerative braking properly.</li>
                                                <li>Employ the EV "eco mode," if available.</li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div className="body indent">
                                        <p>
                                            <h5 className="css_heading bold">EV weight</h5>
                                            <p>Despite battery packs becoming more compact, EVs can be heavier than conventional vehicles. The average curb weight of a light-duty BEV is approximately 450 pounds greater than the average conventional car. For heavy-duty vehicles, the difference can be larger.</p>
                                            <p>To offset the greater weight of the high-voltage battery systems found in EVs, manufacturers have leveraged lightweight materials such as aluminum, ultra-high-strength steel, composites, and carbon fiber. For instance, a Type C electric school bus has the same gross vehicle weight rating (GVWR) of a Type C diesel or propane school bus.</p>
                                        </p>
                                    </div>
                                </div>

                                <div className="referenceContent">
                                    <p>Learn more at <a href="https://fueleconomy.gov" target="_blank" rel="noreferrer">FuelEconomy.gov</a> and the <a href="https://afdc.energy.gov/" target="_blank" rel="noreferrer">Alternative Fuels Data Center</a>.</p>
                                </div>
                            </Col>
                        </Row>

                    </ContentBody>
                </ContentBlock>
        </div >

    );

};
